import type { SanityPageBuilderSection, SanityPageBuilderSpecsRowSection, SanityPageBuilderSpecsRowSpec } from "@ouster/shared";
import { SpecsRowBlockView } from "~/features/blocks/inventory/specs-row";
import { SpecsRowSpecView } from "~/features/blocks/inventory/specs-row/specs-row-spec";
import type { Mode, Theme } from "~/features/ui/get-theme-style";
type Props = {
  section: SanityPageBuilderSection & {
    loaded?: boolean;
    sectionContent: SanityPageBuilderSpecsRowSection;
  };
};
type SpecsRowViewSpec = {
  _key?: SanityPageBuilderSpecsRowSpec["_key"];
  name?: SanityPageBuilderSpecsRowSpec["name"];
  value?: SanityPageBuilderSpecsRowSpec["value"];
};
export function SanitySpecsRowSection({
  section
}: Props) {
  const {
    sectionContent,
    sectionSettings
  } = section;
  const mode = (sectionSettings?.mode || "light") as Mode;
  const theme = (sectionSettings?.theme || "white") as Theme;
  const specs = sectionContent.specs?.map<SpecsRowViewSpec>(spec => ({
    _key: spec._key,
    name: spec.name,
    value: spec.value
  })) ?? [];
  return <SpecsRowBlockView anchor={{
    id: sectionSettings?.sectionId?.current || sectionSettings?.anchorName || section._key,
    name: sectionSettings?.anchorName
  }} getItemKey={(spec, index) => spec._key || index} hasTopDivider={sectionSettings?.hasTopDivider ?? true} mode={mode} renderSpec={spec => <SpecsRowSpecView mode={mode} name={spec.name} theme={theme} value={spec.value} />} sectionProps={{
    "data-sanity-section-key": section._key,
    "data-sanity-section-type": section._type
  }} specs={specs} theme={theme} />;
}